/* ============================================================
 * Channel scaffold hook. Lean marketing pages do not load jQuery,
 * so this must not call $.
 * ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  if (typeof debugLog === 'function') {
    debugLog('log', 'nauticIQ site initialized');
  }
  initializeSiteFeatures();
});

function initializeSiteFeatures() {
  if (typeof debugLog === 'function') {
    debugLog('log', 'Initializing site features for nauticIQ');
  }
}
